import { useTrackUtms } from 'hooks/useUTM'

export function UTMObserver() {
  useTrackUtms()

  return null
}
